import { SanityAsset } from "../model/common";

export interface DownloadOptions {
  overrideFilename?: string;
  showInline?: boolean;
}

export function downloadUrl(
  asset: SanityAsset,
  options?: DownloadOptions
): string {
  const url = `https://cdn.sanity.io/${asset.path}`;
  const fileName = getFileName(asset, options)?.replace(
    /micro:bit/g,
    "microbit"
  );
  if (!fileName) {
    return url;
  }
  if (options?.showInline) {
    return `${url}/${encodeURIComponent(fileName)}`;
  }
  return `${url}?dl=${encodeURIComponent(fileName)}`;
}

const getFileName = (
  asset: SanityAsset,
  options: DownloadOptions | undefined
): string | undefined => {
  const { originalFilename } = asset;
  const { overrideFilename } = options || {};
  if (overrideFilename) {
    return `${overrideFilename}.${asset.extension}`;
  }
  return originalFilename;
};
